import "./SinglePostTemplate.module.css"
import Header from "@/reusable_sections/Header"
import Insight from "./sections/Insight"
import Footer from "@/reusable_sections/Footer"

export default function SinglePostTemplatePage() {

  return (
    <div>
      <Header />
      <Insight />
      <Footer />
    </div>
  )
}
